import { priceFormatter } from '@blockworks/platform';
import { GetAssetResponse } from '@blockworks/platform/api/research';
import { CompactNumber, CompactPrice } from '@blockworks/ui';

import upOrDown from '@/components/pages/price/utils/up-or-down';

interface PriceChartDescriptionProps {
    asset: GetAssetResponse['data'];
}

const PriceChartDescription = (props: PriceChartDescriptionProps): JSX.Element => {
    const {
        asset: {
            title,
            code,
            marketcap: { usdVolume24h },
            change: { usd1h, usd24h },
            supply: { total, circulating },
            price: { usd },
        },
    } = props;

    return (
        <p className="mt-2 text-md text-gray-700" itemProp="description">
            The live {title} price today is {priceFormatter(usd)} with a 24-hour trading volume of{' '}
            <CompactPrice price={usdVolume24h} />. The table above accurately updates our {code} price in real time. The
            price of {code} is {upOrDown(usd1h)}
            <CompactNumber number={usd1h} />% since last hour, {upOrDown(usd24h)}
            <CompactNumber number={usd24h} />% since yesterday. The live market cap, measured by multiplying the number
            of coins by the current price is <CompactPrice price={usd * total} />. {code} has a circulating supply of{' '}
            <CompactNumber number={circulating} /> coins and a max supply of <CompactNumber number={total} /> {code}.
        </p>
    );
};

export default PriceChartDescription;
